import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { getComponentStyles } from "../helpers/component-styles";

// `styles.components` for the current session, or {} when the
// component is mounted outside DataProvider (root.js first paint,
// Storybook). Safe to call unconditionally.
export default function useComponentStyles() {
  const ctx = useContext(DataContext);
  return getComponentStyles(ctx?.data);
}
